import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationWindowComponent, ConfirmationWindowComponentData } from './components/confirmation-window/confirmation-window.component';

@Injectable({
  providedIn: 'root'
})
export class UnsavedDataHelper {
    constructor(private dialog: MatDialog) {}

    checkDirtyElements(arr: number[]): Observable<boolean> {
    let dirtyComponents = ['', '', ''];
      arr.forEach(e => {
        switch (e) {
          case 0:
            dirtyComponents[0] = '<Stammdaten>';
            break;
          case 1:
            dirtyComponents[1] = '<Skilldaten>';
            break;
          case 2:
            dirtyComponents[2] = '<Projektdaten>';
            break;
        }
      });
      const projectDataText = dirtyComponents[0] +' '+ dirtyComponents[1] +' '+ dirtyComponents[2];
      return this.dialog.open<ConfirmationWindowComponentData>(ConfirmationWindowComponent, {
        width: '370px',
        disableClose: true,
        position: {top: '20px'},
        data: {
          projectDataText: projectDataText,
        }
      }).afterClosed();
    }
}
